import QuestionAnswerModal from './QuestionAnswerModal';

export default QuestionAnswerModal;
export {
  getBiradsChipColor,
  getQuestionModalConfig,
  normalizeFormData
} from './questionModalConfigs';
export type {
  QuestionFieldConfig,
  QuestionFieldType,
  QuestionModalityConfig
} from './questionModalConfigs';
